import { CommonModule, DatePipe } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, TemplateRef, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom, Subscription, take } from 'rxjs';
import { DeleteRentalService } from 'src/app/services/deleterental';
import { LayoutService } from 'src/app/services/layout.service';
import { MarketInfoService } from 'src/app/services/marketInfo.service';
import { OperationRentalService } from 'src/app/services/Rentals.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { IVendorsFilterOptions } from 'src/app/Shared/model/VendorsModel';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { VendorSearchComponent } from 'src/app/Shared/vendor-search/vendor-search.component';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import Swal from 'sweetalert2';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import printJS from 'print-js';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EBaseTemplateID } from 'src/app/Shared/enum';
import { GeneralService } from 'src/app/services/general.service';
import { PosOpeningCashDrawerService } from 'src/app/services/pos_OpeningCashDrawer.service';
import { IOpenCashModel } from 'src/app/Shared/Interfaces/IPOSSettings';
import { Router } from '@angular/router';
import { OpsOpeningCashDrawerAmount } from 'src/app/operations/ops-point-of-sales/ops-opening-cash-drawer-amount/ops-opening-cash-drawer-amount';
import { ASLicenseSettings } from 'src/app/Shared/model/GeneralModel';
declare var bootstrap: any;

@Component({
  selector: 'app-ops-delete-rental',
  standalone: true,
  imports: [TopBarComponent, SYNCFUSION_MODULES, CommonModule, ANGULAR_MODULES,
    OperationsComponent, VendorSearchComponent, WordReplacePipe, LoaderComponent,
    OpsOpeningCashDrawerAmount],
  templateUrl: './ops-delete-rental.html',
  styleUrl: './ops-delete-rental.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OpsDeleteRental {
  @ViewChild('Bookingsgrid', { static: false }) public Bookingsgrid: GridComponent;
  @ViewChild('gridOtherItems', { static: false }) public gridOtherItems: GridComponent;
  @ViewChild('gridDeleteBooking', { static: false }) public gridDeleteBooking: GridComponent;
  originalRentValues: { id: number, originalRent: string, originalSecLevelTax: string, originalSalesTax: string }[] = [];
  public loaderIcon: Promise<boolean>;
  private subscriptions: Subscription[] = [];
  searchOption: number;
  isCollapsed: boolean = true;
  DeleteRentalForm: FormGroup;
  filterData;
  VendorFilterOption = {
    All: true,
    Current: false,
    Inactive: false,
    PageModel: {
      pageCount: 1,
      pageSize: 20
    }
  };
  modalRef!: NgbModalRef;
  selectedBoothData: any;
  allAvailableBooths: any;
  allAvailableBoothsOriginal: any;
  defaultRentalNotes: any;
  vendorComments: any;
  parts: any;
  selectedvendorId: number = 0;
  selectedOtherItems: any[];
  vendorProducts = [];
  defaultProduct;
  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }
  DisableRefundPay = true;
  PaymentSettings;
  VerifoneId = 0;
  selectedBookingBooths = [];
  DeleteBooking = [];
  isSaveEnabled: boolean = false;
  RentaltypeList: string;
  daily = false;
  combinedMonthly = false;
  combinedWeekly = false;
  pdfUrl: SafeResourceUrl | null = null;
  dayendRowData;
  dayendOrOpenCashNotSaved = false;
  hideOpenCashTopMenu = false;
  openCashNotSet = false;
  canDisplaySaveAndRefund: boolean = false;
  noLayout = false;

  constructor(private formBuilder: FormBuilder,
    private layoutService: LayoutService,
    private vendorService: VendorService,
    private customCurrency: customCurrencyPipe,
    private datePipe: DatePipe,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private toastr: ToastrService,
    private deleteRentalService: DeleteRentalService,
    private operationRentalService: OperationRentalService,
    private marketInfoService: MarketInfoService,
    private sanitizer: DomSanitizer,
    private generalService: GeneralService,
    private posOpeningCashDrawerService: PosOpeningCashDrawerService,
    private router: Router
  ) {
    const today = new Date();
    this.DeleteRentalForm = this.formBuilder.group({
      searchOption: ['1'],
      rentalType: ['4'],
      chkVendorIdValue: [''],
      chkVendorName: [''],
      TransactionDate: [today],
      VendorComments: [''],
      rentalNotes: [null],
      txtBooth: [''],
      isRefundMode: [{ value: false, disabled: true }],

      ReceiptAndContractSetting: this.formBuilder.group({
        ZeroOutUI: [false],
        printReceipt: [false],
        displayReceipt: [false],
        emailReceipt: [false],
      }),
      refundCharges: this.formBuilder.group({
        rentRefund: [this.customCurrency.transform('0.00')],
        otherChargesRefund: [this.customCurrency.transform('0.00')],
        salesTaxRefund: [this.customCurrency.transform('0.00')],
        secLevelTaxRefund: [this.customCurrency.transform('0.00')],
        discountRefund: [this.customCurrency.transform('0.00')],
        priorArBalance: [this.customCurrency.transform('0.00')],
        totalRefundAmt: [this.customCurrency.transform('0.00')],
      }),
      otherRefundCharges: this.formBuilder.group({
        cashRefund: [this.customCurrency.transform('0.00')],
        ccRefund: [this.customCurrency.transform('0.00')],
        balanceDue: [this.customCurrency.transform('0.00')],
      })
    })
  }

  ngOnInit(): void {
    this.checkOpenCashSavedForTrans();
    this.getASCloudLicenseSettings();
    this.getParts();
    this.getRentalType();
    this.DisplaySaveAndRefund();
    document.body.style.setProperty("overflow", "scroll", "important");
  }

  DisplaySaveAndRefund(): void {
    this.deleteRentalService.CanDisplaySaveAndRefund()
      .pipe(take(1))
      .subscribe(res => this.canDisplaySaveAndRefund = res);
  }

  checkOpenCashSavedForTrans() {
    this.posOpeningCashDrawerService.checkOpenCashSavedForTransaction()
      .pipe(take(1))
      .subscribe({
        next: (response: IOpenCashModel) => {
          this.loaderIcon = Promise.resolve(false);
          var posOpenCashDetails = response;
          if (posOpenCashDetails && posOpenCashDetails.PreviousEODNotProcessedDate) {
            const dateEODNotProcessed = posOpenCashDetails.PreviousEODNotProcessedDate.substring(5, 7) + '/' + posOpenCashDetails.PreviousEODNotProcessedDate.substring(8, 10) + '/' + posOpenCashDetails.PreviousEODNotProcessedDate.substring(0, 4);
            posOpenCashDetails.PreviousEODNotProcessedDate.substring(0, 10)
            Swal.fire({
              text: $localize`:@@MsgDayendForDateNotSubmitted:The Day end for date: ${dateEODNotProcessed} is not submitted!`,
              icon: 'warning',
              confirmButtonText: $localize`:@@Ok:Ok`,
              didClose: async () => {
                const result = await Swal.fire({
                  title: $localize`Confirm`,
                  text: $localize`Are you sure you want to process dayend for ${dateEODNotProcessed}`,
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonText: $localize`Yes`,
                  cancelButtonText: $localize`No`
                });

                if (result.isConfirmed) {
                  const userData = await lastValueFrom(
                    this.generalService.getLoggedInUserAndTerminal().pipe(take(1))
                  );
                  this.dayendRowData = {
                    UserId: userData.UserId,
                    Terminal: userData.TerminalName,
                    OpeningCashDate: this.datePipe.transform(posOpenCashDetails.PreviousEODNotProcessedDate, "yyyy-MM-dd")
                  }
                  this.generalService.setDayendRowDataForTrans(this.dayendRowData);
                  var url = 'ops/pos/day-end-process/trans';
                  this.router.navigate([url]);
                } else {
                  this.dayendOrOpenCashNotSaved = true;
                }
              }
            });
          }
          else if (!posOpenCashDetails || posOpenCashDetails.Id == 0) {
            this.hideOpenCashTopMenu = true;
            this.openCashNotSet = true
            this.openModalById('modalOpenCash')
          }
        }
      })
  }

  getASCloudLicenseSettings(): void {
    const licenseSettings = this.generalService.ASLicenseSettings;
    if (licenseSettings !== null) {
      this.noLayout = licenseSettings.NoLayout ?? false;
      return;
    }

    this.generalService.getASCloudLicenseSettings().pipe(take(1)).subscribe({
      next: (res: ASLicenseSettings) => {
        this.generalService.ASLicenseSettings = res;
        this.noLayout = res.NoLayout ?? false;
      },
      error: () => {
        this.noLayout = false;
      }
    });
  }

  openModalById(modalId) {
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const modal = new bootstrap.Modal(
      document.getElementById(modalId)!,
      {
        backdrop: 'static',
        keyboard: false,
        focus: true
      }
    );
    modal.show();
  }

  openCashSaved(val) {
    this.openCashNotSet = false;
    this.closeModalById('modalOpenCash');
  }

  btnCloseOpenCash() {
    this.dayendOrOpenCashNotSaved = true;
    this.closeModalById('modalOpenCash');
  }

  closeModalById(modalId: string) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      const modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
    document.body.classList.remove('modal-open');

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  onSearchOptionBlur(): void {
    this.resetForm();
  }

  getRentalType() {
    this.loaderIcon = Promise.resolve(true);

    this.subscriptions.push(
      this.marketInfoService.getRentalType().subscribe((res: any) => {

        this.daily = false;
        this.combinedWeekly = false;
        this.combinedMonthly = false;

        if (res) {
          this.RentaltypeList = res;

          this.RentaltypeList.split(',').forEach((el: string) => {
            switch (el.trim()) {
              case '1': this.daily = true; break;
              case '4': this.combinedMonthly = true; break;
              case '5': this.combinedWeekly = true; break;
            }
          });
        }

        this.getRentalPaymentSettings();
        this.loaderIcon = Promise.resolve(false);
      },
        () => this.loaderIcon = Promise.resolve(false)
      ));
  }


  getParts() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.layoutService.getParts().subscribe((res: any) => {
      if (res) {
        this.parts = res;
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  loadVendorDetails() {
    this.DeleteRentalForm.patchValue({
      isRefundMode: false
    });

    if (this.selectedvendorId > 0) {
      this.resetRefundForms();
      this.getVendorBalances();
      // this.getVendorComment();
      this.selectedBookingBooths = []
      this.DeleteBooking = []
      if (this.DeleteRentalForm.get('rentalType').value == 4) { this.getCombinedMonthlyRental(); }
    }
    (error) => {
      console.error('Error occurred:', error);
    }
  }

  private resetRefundForms() {

    this.DeleteRentalForm.patchValue({

      refundCharges: {
        rentRefund: this.customCurrency.transform('0.00'),
        otherChargesRefund: this.customCurrency.transform('0.00'),
        salesTaxRefund: this.customCurrency.transform('0.00'),
        secLevelTaxRefund: this.customCurrency.transform('0.00'),
        discountRefund: this.customCurrency.transform('0.00'),
        totalRefundAmt: this.customCurrency.transform('0.00')
      },

      otherRefundCharges: {
        cashRefund: this.customCurrency.transform('0.00'),
        ccRefund: this.customCurrency.transform('0.00'),
        balanceDue: this.customCurrency.transform('0.00')
      }

    });

    this.isSaveEnabled = false;
  }

  checkSaveButtonState() {
    const hasRefundQty = this.selectedOtherItems.some(item => Number(item.qtyToDelete) > 0);
    const hasDeleteBookings = this.DeleteBooking && this.DeleteBooking.length > 0;

    this.isSaveEnabled = hasRefundQty || hasDeleteBookings;
  }

  private async confirmUnsavedChanges(): Promise<boolean> {
    // No pending changes
    if (!this.isSaveEnabled) {
      return true;
    }

    const result = await Swal.fire({
      title: 'Unsaved Changes',
      text: 'Booking Information has been modified. Do you wish to continue without saving them?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false,
      allowEscapeKey: false
    });

    return result.isConfirmed;
  }

  updateRefund(data: any) {
    if (data.ZeroOut) {
      return;
    }
    
    let updatedItem = this.DeleteBooking.find(item => item.MonthlyRentalId == data.MonthlyRentalId);
    if (updatedItem) {
      let parsedValue = this.parseCurrencyValue(data.RentRefund);
      let rentValue = this.parseCurrencyValue(updatedItem.Rent);
      if (isNaN(parsedValue) || parsedValue === null || parsedValue > rentValue) {
        parsedValue = rentValue;
      }

      updatedItem.RentRefund = this.customCurrency.transform(parsedValue.toString());

      this.gridDeleteBooking.refresh();
      this.CalculateDue();
      this.updateRefundCheckboxState();
    }
  }

  numberOnly(event: KeyboardEvent): boolean {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'];

    if (allowedKeys.includes(event.key)) {
      return true;
    }

    const regex = /^[0-9.]$/;

    if (!regex.test(event.key)) {
      event.preventDefault();
      return false;
    }

    return true;
  }

  getCombinedMonthlyRental() {
    this.getVendorProducts();
    this.loaderIcon = Promise.resolve(true);
    this.selectedBookingBooths = [];
    var existingBooths = [];
    let RentVal: number = 0
    const sub = this.deleteRentalService.getCombinedMonthlyBookings(this.selectedvendorId).subscribe((res: any[]) => {
      if (res) {
        existingBooths = res;
        existingBooths.forEach((el) => {
          this.Bookingsgrid.refresh();
          const ob = {
            MonthlyRentalId: el.MonthlyRentalId,
            BoothNumber: el.BoothNumber,
            BoothType: el.BoothType,
            BoothTypeId: el.BoothTypeId,
            RentalYearMonth: this.datePipe.transform(this.yearMonthToDate(el.RentalYearMonth), 'MMMM-yyyy'),
            RentalStartDate: this.datePipe.transform(el.RentalStartDate, 'MMM d, y'),
            RentalEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
            RentalSavedEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
            RentStartPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
            RentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
            Product: el.ProductId,
            Rent: this.customCurrency.transform(el.RentalCharge),
            SalesTax: this.customCurrency.transform(el.SalesTax),
            SecLevelTax: this.customCurrency.transform(el.SecLevelTax),
            Sunday: el.Sunday,
            Monday: el.Monday,
            Tuesday: el.Tuesday,
            Wednesday: el.Wednesday,
            Thursday: el.Thursday,
            Friday: el.Friday,
            Saturday: el.Saturday,
            Reservation: el.BoothReserved,
            Drop: el.DoNotRenew,
            Status: el.Status,
            January: this.customCurrency.transform('0.00'),
            February: this.customCurrency.transform('0.00'),
            March: this.customCurrency.transform('0.00'),
            April: this.customCurrency.transform('0.00'),
            May: this.customCurrency.transform('0.00'),
            June: this.customCurrency.transform('0.00'),
            July: this.customCurrency.transform('0.00'),
            August: this.customCurrency.transform('0.00'),
            September: this.customCurrency.transform('0.00'),
            October: this.customCurrency.transform('0.00'),
            November: this.customCurrency.transform('0.00'),
            December: this.customCurrency.transform('0.00'),
            JanuaryMonthPresent: el.JanuaryMonthPresent,
            FebruaryMonthPresent: el.FebruaryMonthPresent,
            MarchMonthPresent: el.MarchMonthPresent,
            AprilMonthPresent: el.AprilMonthPresent,
            MayMonthPresent: el.MayMonthPresent,
            JuneMonthPresent: el.JuneMonthPresent,
            JulyMonthPresent: el.JulyMonthPresent,
            AugustMonthPresent: el.AugustMonthPresent,
            SeptemberMonthPresent: el.SeptemberMonthPresent,
            OctoberMonthPresent: el.OctoberMonthPresent,
            NovemberMonthPresent: el.NovemberMonthPresent,
            DecemberMonthPresent: el.DecemberMonthPresent,
            NewBooth: false
          }
          this.selectedBookingBooths.push(ob);

        });
        this.Bookingsgrid.refresh();
        this.loaderIcon = Promise.resolve(false);
      }

    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
    this.getMonthlyOtherRentals();
  }

  private yearMonthToDate(yearMonth: number | string): Date | null {
    if (!yearMonth) return null;

    const ym = yearMonth.toString();
    const year = Number(ym.substring(0, 4));
    const month = Number(ym.substring(4, 6)) - 1; // JS months are 0-based

    return new Date(year, month, 1);
  }

  async getMonthlyOtherRentals() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedOtherItems = [];

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const currentYearMonth = `${currentYear}${currentMonth < 10 ? '0' : ''}${currentMonth}`;

    const res = await lastValueFrom(
      this.deleteRentalService.GetCombinedMonthlyOtherRentals(this.selectedvendorId)
    );

    const current = parseInt(
      new Date().toISOString().slice(0, 7).replace("-", "")
    );

    if (res) {
      this.selectedOtherItems = res
        .filter((r: any) => parseInt(r.YearMonth) >= current)
        .map((r: any) => ({
          otherRentalId: r.OtherRentalId,
          accountReceiptId: r.AccountReceiptId,
          otherItemId: r.OtherItemId,
          quantity: r.Quantity,
          otherItemCategory: r.OtherItemCategory,
          boothNumber: r.BoothNumber,
          item: r.OtherItemName,
          yearMonth: r.YearMonth,
          otherCharge: this.customCurrency.transform(r.OtherCharge),
          salesTax: this.customCurrency.transform(r.SalesTax),
          secLevelTax: this.customCurrency.transform(r.SecLevelTax),
          rec: r.Recurring,
          reservedOnly: r.ReservedOnly,
          reference: r.Reference,
          unitCharge: this.customCurrency.transform(r.OtherCharge?.toString() ?? '0'),
          rentalUnitCharge: this.customCurrency.transform(r.OtherCharge?.toString() ?? '0'),
          rentalPeriod: this.datePipe.transform(this.yearMonthToDate(r.YearMonth), 'MMMM-yyyy'),
          qty: r.Quantity,
          qtyToDelete: 0,
          OtherItemCharge_Refund: this.customCurrency.transform('0'),
          SalesTax_Refund: this.customCurrency.transform('0'),
          secleveltax_Refund: this.customCurrency.transform('0'),
        }));

      this.loaderIcon = Promise.resolve(false);
    }
    this.gridOtherItems.refresh();
    this.checkSaveButtonState();
  }

  getRentalUnitCharge(row: any): string {
    if (!row || !row.unitCharge) {
      return this.customCurrency.transform('0');
    }

    const unitCharge = this.parseCurrencyValue(row.unitCharge) || 0;
    const qty = row.qtyToDelete || 0;

    const amount = qty > 0 ? unitCharge * qty : unitCharge;
    return this.customCurrency.transform(amount.toString());
  }

  onQtyToDeleteChange(row: any, event: any) {
    const enteredValue = parseInt(event.target.value, 10) || 0;
    if (enteredValue > row.qty) {
      row.qtyToDelete = row.qty;
      event.target.value = row.qty;
    } else {
      row.qtyToDelete = enteredValue;
    }
    this.checkSaveButtonState();
    // this.checkSaveAndRefundState();
  }

  updateotheritemlist(data: any, event: any): void {
    const quantity = data.qty || 0;
    const unitCharge = this.parseCurrencyValue(data.rentalUnitCharge
    ) || 0;
    const SalesTax = this.parseCurrencyValue(data.salesTax
    ) || 0;
    const SecLevelTax = this.parseCurrencyValue(data.secLevelTax
    ) || 0;
    let totalCharge_Refund = 0;
    let totalSalesTax_Refund = 0;
    let totalsecleveltax_Refund = 0;
    const quantity_Refund = data.qtyToDelete || 0;
    const index = this.selectedOtherItems.findIndex(item => {
      if (this.DeleteRentalForm.get('rentalType').value === "1") {
        return item.otherItemId === data.otherItemId &&
          item.otherRentalId === data.otherRentalId
          &&
          item.item === data.item;
      } else if (this.DeleteRentalForm.get('rentalType').value === "4") {
        return item.otherItemId === data.otherItemId &&
          item.otherRentalId === data.otherRentalId
          &&
          item.item === data.item;
      } else if (this.DeleteRentalForm.get('rentalType').value === "5") {
        return item.otherItemId === data.otherItemId &&
          item.otherRentalId === data.otherRentalId
          &&
          item.item === data.item;
      }
      return false;
    });
    if (quantity_Refund <= quantity) {
      totalCharge_Refund = unitCharge * quantity_Refund;
      totalSalesTax_Refund = (SalesTax / quantity) * quantity_Refund
      totalsecleveltax_Refund = (SecLevelTax / quantity) * quantity_Refund
      if (index !== -1) {
        this.selectedOtherItems[index].qtyToDelete = quantity_Refund;
        this.selectedOtherItems[index].OtherItemCharge_Refund = this.customCurrency.transform(totalCharge_Refund.toString());
        this.selectedOtherItems[index].SalesTax_Refund = this.customCurrency.transform(totalSalesTax_Refund.toString());
        this.selectedOtherItems[index].secleveltax_Refund = this.customCurrency.transform(totalsecleveltax_Refund.toString());
      }
    } else {
      this.selectedOtherItems[index].qtyToDelete = quantity;
      this.selectedOtherItems[index].OtherItemCharge_Refund = this.customCurrency.transform((unitCharge * quantity).toString());
      this.selectedOtherItems[index].SalesTax_Refund = this.customCurrency.transform((SalesTax).toString());
      this.selectedOtherItems[index].secleveltax_Refund = this.customCurrency.transform((SecLevelTax).toString());
    }

    this.gridOtherItems.refresh();
    this.checkSaveButtonState();
  }

  moveToDeletedBookings() {
    const selectedIndexes = this.Bookingsgrid.getSelectedRowIndexes();
    if (selectedIndexes.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Are you sure you want to delete this booking?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {

          selectedIndexes.sort((a, b) => b - a);
          selectedIndexes.forEach(index => {
            const item = this.selectedBookingBooths.splice(index, 1)[0];

            item.MakeAvail = true;
            item.DelBooking = true;
            item.RentRefund = item.Rent;
            item.OriginalRentalEndDate = item.RentalEndDate;
            item.UpdatedRentalEndDate = item.RentalEndDate;

            item.AvailableEndDates = this.generateRentalEndDates(
              item.RentalStartDate,
              item.RentalEndDate
            );

            this.DeleteBooking.unshift(item);
          });
          this.Bookingsgrid.clearSelection();
          this.Bookingsgrid.refresh();
          this.gridDeleteBooking.refresh();
          this.CalculateDue();
          this.updateRefundCheckboxState();

          this.DeleteBooking.forEach((item: any) => {
            const startDate = new Date(item.RentalStartDate);
            const endDate = new Date(item.RentalEndDate);
            item.OriginalRentalEndDate = this.formatDate(endDate);
            item.UpdatedRentalEndDate = this.formatDate(endDate);
            item.AvailableEndDates = [];
            const current = new Date(startDate);

            while (current <= endDate) {
              item.AvailableEndDates.push(
                this.formatDate(current)
              );
              current.setDate(current.getDate() + 1);
            }
          });
        }
      });
    }
    else {
      Swal.fire({
        title: 'No selection',
        text: 'Please select the booth to be deleted',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'OK'
      });
    }
  }

  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };
    return new Date(date).toLocaleDateString('en-US', options);
  }

  formatDateForApi(date: any): string {
    if (!date) {
      return '';
    }
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1)
      .toString()
      .padStart(2, '0');
    const day = d.getDate()
      .toString()
      .padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  applyDelBookingForRow(row: any) {
    if (!row.DelBooking) {
      row.MakeAvail = true;
    }
    else {
      row.UpdatedRentalEndDate =
        row.OriginalRentalEndDate;
    }

    const index = this.DeleteBooking.findIndex(
      x => x.MonthlyRentalId === row.MonthlyRentalId
    );

    if (index !== -1) {
      this.DeleteBooking[index] = { ...row };
    }
    this.gridDeleteBooking.refresh();
  }

  applyMakeAvailForRow(row: any) {
    // Cannot uncheck MakeAvail
    // when DelBooking unchecked
    if (!row.DelBooking && !row.MakeAvail) {
      row.MakeAvail = true;
    }

    const index = this.DeleteBooking.findIndex(
      x => x.MonthlyRentalId === row.MonthlyRentalId
    );

    if (index !== -1) {
      this.DeleteBooking[index] = { ...row };
    }
    this.gridDeleteBooking.refresh();
  }

  onRentalEndDateChange(row: any) {
    // Prevent change if DelBooking checked
    if (row.DelBooking) {
      row.UpdatedRentalEndDate =
        row.OriginalRentalEndDate;
      return;
    }

    const index = this.DeleteBooking.findIndex(
      x => x.MonthlyRentalId === row.MonthlyRentalId
    );

    if (index !== -1) {

      this.DeleteBooking[index] = { ...row };
    }
    this.updateRefund(row);
    this.gridDeleteBooking.refresh();
  }

  generateRentalEndDates(startDate: any, endDate: any): Date[] {
    const dates: Date[] = [];
    const start = new Date(startDate);
    const end = new Date(endDate);
    const current = new Date(start);

    while (current <= end) {
      dates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }

    return dates;
  }

  revertDeletedBookings() {
    const selectedIndexes = this.gridDeleteBooking.getSelectedRowIndexes();
    if (selectedIndexes.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Are you sure you want to restore this deleted booking?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          selectedIndexes.sort((a, b) => b - a);
          selectedIndexes.forEach(index => {
            const item = this.DeleteBooking.splice(index, 1)[0];
            const originalValues = this.originalRentValues.find(r => r.id === item.MonthlyRentalId);
            if (originalValues) {
              item.Rent = originalValues.originalRent;
              item.SecLevelTax = originalValues.originalSecLevelTax;
              item.SalesTax = originalValues.originalSalesTax;
              item.ZeroOut = false;
            }

            this.selectedBookingBooths.unshift(item);
          });
          this.gridDeleteBooking.clearSelection();
          this.Bookingsgrid.refresh();
          this.gridDeleteBooking.refresh();
          this.CalculateDue();
          this.updateRefundCheckboxState();
        }
      });
    } else {
      Swal.fire({
        title: 'No selection',
        text: 'Please select the booth to be restored',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'OK'
      });
    }
  }

  onCancelClick() {
    if (this.selectedvendorId > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Are you sure you want to cancel?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          this.resetForm();
        }
      });

      return;
    }

    this.resetForm();
  }

  private resetForm() {
    this.DeleteBooking = [];
    this.selectedOtherItems = [];
    this.selectedBookingBooths = [];
    this.selectedvendorId = 0;

    this.DeleteRentalForm.patchValue({
      txtBooth: '',
      chkVendorIdValue: '',
      chkVendorName: '',
      VendorComments: '',
      rentalNotes: '',
      isRefundMode: false,
      ReceiptAndContractSetting: {
        displayReceipt: false,
        printReceipt: false,
        emailReceipt: false,
        displayContract: false,
        printContract: false,
        emailContract: false,
        m_BlnZeroOutRefund: false,
        ZeroOutUI: false
      },

      refundCharges: {
        rentRefund: this.customCurrency.transform('0.00'),
        otherChargesRefund: this.customCurrency.transform('0.00'),
        SalesTaxRefund: this.customCurrency.transform('0.00'),
        SecondLeveltaxRefund: this.customCurrency.transform('0.00'),
        discountRefund: this.customCurrency.transform('0.00'),
        lateFee: this.customCurrency.transform('0.00'),
        priorArBalance: this.customCurrency.transform('0.00'),
        totalRefundAmt: this.customCurrency.transform('0.00')
      },

      otherRefundCharges: {
        cashRefund: this.customCurrency.transform('0.00'),
        ccRefund: this.customCurrency.transform('0.00'),
        balanceDue: this.customCurrency.transform('0.00')
      }
    });

    this.checkSaveButtonState();
    this.DeleteRentalForm.get('isRefundMode')?.disable();
  }

  applyZeroOutForRow(row: any) {
    // console.log("ZeroOut clicked:", row);
    if (row.ZeroOut) {
      if (!this.originalRentValues.some(x => x.id === row.MonthlyRentalId)) {
        this.originalRentValues.push({
          id: row.MonthlyRentalId,
          originalRent: row.Rent,
          originalSecLevelTax: row.SecLevelTax,
          originalSalesTax: row.SalesTax
        });
      }
      row.RentRefund = this.customCurrency.transform('0.00');
      row.SalesTax = this.customCurrency.transform('0.00');
      row.SecLevelTax = this.customCurrency.transform('0.00');

    } else {
      const original = this.originalRentValues.find(x => x.id === row.MonthlyRentalId);
      if (original) {
        row.RentRefund = original.originalRent;
        row.SalesTax = original.originalSalesTax;
        row.SecLevelTax = original.originalSecLevelTax;
      }
    }
    const index = this.DeleteBooking.findIndex(x => x.MonthlyRentalId === row.MonthlyRentalId);
    if (index !== -1) {
      this.DeleteBooking[index] = { ...row };
    }
    this.gridDeleteBooking.refresh();
    this.CalculateDue();
    this.updateRefundCheckboxState();
  }

  CalculateDue() {
    this.checkSaveButtonState();
    let rentRefund = 0;
    let salesrefund = 0;
    let SecLevelTax = 0;
    let otherChargesRefund = 0;

    this.DeleteBooking.forEach(x => {
      rentRefund += parseFloat(x.RentRefund.replace(/[^0-9.-]/g, ''));
    });
    this.DeleteBooking.forEach(x => {
      salesrefund += parseFloat(x.SalesTax.replace(/[^0-9.-]/g, ''));
    });
    this.DeleteBooking.forEach(x => {
      SecLevelTax += parseFloat(x.SecLevelTax.replace(/[^0-9.-]/g, ''));
    });

    this.selectedOtherItems.forEach(x => {
      if (x.qtyToDelete > 0) {
        otherChargesRefund += this.parseCurrencyValue(x.OtherItemCharge_Refund);
        salesrefund += this.parseCurrencyValue(x.SalesTax_Refund);
        SecLevelTax += this.parseCurrencyValue(x.secleveltax_Refund);
      }
    });

    this.DeleteRentalForm.controls['refundCharges'].get('rentRefund').setValue(this.customCurrency.transform(rentRefund.toString()));
    this.DeleteRentalForm.controls['refundCharges'].get('salesTaxRefund').setValue(this.customCurrency.transform(salesrefund.toString()));
    this.DeleteRentalForm.controls['refundCharges'].get('secLevelTaxRefund').setValue(this.customCurrency.transform(SecLevelTax.toString()));
    this.DeleteRentalForm.controls['refundCharges'].get('otherChargesRefund').setValue(this.customCurrency.transform(otherChargesRefund.toString()));
    const priorArBalanceValue = this.DeleteRentalForm.controls['refundCharges'].get('priorArBalance')?.value || '0.00';

    const totalRefundAmt = (
      otherChargesRefund + rentRefund + salesrefund + SecLevelTax +
      -1 * this.parseCurrencyValue(priorArBalanceValue));

    this.DeleteRentalForm.controls['refundCharges'].get('totalRefundAmt').setValue(this.customCurrency.transform(totalRefundAmt.toString()));

    let ccRefundValue =
      this.parseCurrencyValue(
        this.DeleteRentalForm.get('otherRefundCharges.ccRefund')?.value || '0'
      );

    let cashRefundValue = 0;

    const isRefundMode =
      this.DeleteRentalForm.get('isRefundMode')?.value === true;

    if (isRefundMode && totalRefundAmt >= 0) {

      cashRefundValue = totalRefundAmt;

      this.DeleteRentalForm.get('otherRefundCharges.cashRefund')
        ?.setValue(
          this.customCurrency.transform((-cashRefundValue).toString()),
          { emitEvent: false }
        );

    }
    else {

      cashRefundValue = 0;

      this.DeleteRentalForm.get('otherRefundCharges.cashRefund')
        ?.setValue(
          this.customCurrency.transform('0.00'),
          { emitEvent: false }
        );

    }

    const balanceDue =
      isRefundMode
        ? totalRefundAmt - (cashRefundValue + ccRefundValue)
        : totalRefundAmt;

    this.DeleteRentalForm.get('otherRefundCharges.balanceDue')
      ?.setValue(
        this.customCurrency.transform((-balanceDue).toString())
      );
  }

  parseCurrencyValue(value: string): number {
    value = value.replace(/[$,]/g, '');
    const matches = value.match(/^\((.*?)\)$/);
    if (matches && matches.length === 2) {
      return -parseFloat(matches[1]);
    } else {
      return parseFloat(value);
    }
  }

  getVendorProducts() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.vendorService.GetVendorProductsById(this.selectedvendorId).subscribe((res: any) => {
      if (res) {
        this.vendorProducts = res.body;
        this.defaultProduct = this.vendorProducts[0].ProductId;
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  GotoSave(): void {
    if (this.openCashNotSet || this.dayendOrOpenCashNotSaved) {
      Swal.fire({
        text: `Please enter opening cash drawer amount in 'Opg Cash - Drawer Amt' module and then save the record..!`,
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    const invalidPartialDeleteItem =
      this.DeleteBooking.find(x =>
        !x.DelBooking &&
        x.UpdatedRentalEndDate === x.OriginalRentalEndDate
      );

    if (invalidPartialDeleteItem) {
      Swal.fire({
        title: 'Delete Rental',
        html:
          `Please Delete the booking partially by changing the Rental End Date
           <br>or<br>
          delete the Entire booking for Booth #${invalidPartialDeleteItem.BoothNumber} and ${invalidPartialDeleteItem.RentalYearMonth}!!`,
        icon: 'info',
        confirmButtonText: 'OK'
      });

      return;
    }

    try {
      const ccAmountRaw = this.DeleteRentalForm.controls['otherRefundCharges'].get('ccRefund')?.value ?? '0';
      const ccAmount = parseFloat(
        (ccAmountRaw as string).replace(/[^0-9.-]/g, '')) || 0;

      if (this.PaymentSettings?.McsBitProcessCreditCardOnline && ccAmount > 0) {
        // this.MakeCCPayment();
      } else {
        this.SavedeleteCMonthlyRentals();
      }
    } catch (error) {
      console.error('Error during save:', error);
    } finally {
      setTimeout(() => {
      }, 1000);
    }
  }

  onRefundModeChanged() {
    const isRefundMode =
      this.DeleteRentalForm.get('isRefundMode')?.value === true;

    if (!isRefundMode) {
      this.DeleteRentalForm.patchValue({
        otherRefundCharges: {
          cashRefund: this.customCurrency.transform('0.00'),
          ccRefund: this.customCurrency.transform('0.00')
        }
      });
    }

    this.CalculateDue();
  }


  async SavedeleteCMonthlyRentals() {

    const userData = await lastValueFrom(
      this.generalService.getLoggedInUserAndTerminal().pipe(take(1))
    );

    const terminalName = userData?.TerminalName;

    const rentRefund = -1 * this.parseCurrencyValue(this.DeleteRentalForm.controls['refundCharges'].get('rentRefund').value);
    const OtheritemrentRefund = -1 * this.parseCurrencyValue(this.DeleteRentalForm.controls['refundCharges'].get('otherChargesRefund').value);
    const salestaxrefund = -1 * this.parseCurrencyValue(this.DeleteRentalForm.controls['refundCharges'].get('salesTaxRefund').value);
    const secleveltaxrefund = -1 * this.parseCurrencyValue(this.DeleteRentalForm.controls['refundCharges'].get('secLevelTaxRefund').value);
    const isRefundMode =
      this.DeleteRentalForm.get('isRefundMode')?.value === true;

    const cashRefundValue =
      isRefundMode
        ? -1 * parseFloat(this.DeleteRentalForm.controls['otherRefundCharges']
          .get('cashRefund').value.replace(/[^0-9.-]/g, ''))
        : 0;

    const ccAmountRefundValue =
      isRefundMode
        ? -1 * parseFloat(this.DeleteRentalForm.controls['otherRefundCharges']
          .get('ccRefund').value.replace(/[^0-9.-]/g, ''))
        : 0;

    // const AmountPaid = parseFloat((cashRefundValue + ccAmountRefundValue).toString());

    let AmountPaid = 0;
    let AmountPaid_cash = 0;
    let AmountPaid_CC = 0;

    if (isRefundMode) {
      AmountPaid_cash = cashRefundValue;
      AmountPaid_CC = ccAmountRefundValue;
      AmountPaid = AmountPaid_cash + AmountPaid_CC;
    }

    const balanceDue = this.parseCurrencyValue(this.DeleteRentalForm.controls['otherRefundCharges'].get('balanceDue').value);
    const priorArBalanceValue = this.parseCurrencyValue(this.DeleteRentalForm.controls['refundCharges'].get('priorArBalance').value);


    const vendorid = this.selectedvendorId;

    const cleanedselectedOtherItems = this.selectedOtherItems.map((item: any) => ({
      OtherRentalId: item.otherRentalId ?? 0,
      AccountReceiptId: item.accountReceiptId ?? 0,
      OtherItemId: item.otherItemId ?? null,
      Quantity: Number(item.qty) ?? null,
      OtherItemCategory: item.otherItemCategory ?? null,
      BoothNumber: item.boothNumber ?? '',
      OtherItemName: item.item?.toString() ?? null,
      YearMonth: item.yearMonth,
      OtherCharge: this.parseCurrencyValue(item.rentalUnitCharge),
      Recurring: item.rec ?? false,
      ReservedOnly: item.reservedOnly ?? false,
      SalesTax: this.parseCurrencyValue(item.salesTax) ?? 0,
      SecLevelTax: this.parseCurrencyValue(item.secLevelTax) ?? 0,
      Reference: item.reference ?? null,
      Quantity_Refund: item.qtyToDelete ?? 0,
      SalesTax_Refund: -1 * this.parseCurrencyValue(item.SalesTax_Refund ?? 0),
      CityTax_Refund: 0,
      SecLevelTax_Refund: -1 * this.parseCurrencyValue(item.secleveltax_Refund ?? 0),
      OtherItemCharge_Refund: -1 * this.parseCurrencyValue(item.OtherItemCharge_Refund ?? 0),
    }));

    const cleanedDeleteBooking = this.DeleteBooking.map(item => ({
      MonthlyRentalId: item.MonthlyRentalId,
      BoothNumber: item.BoothNumber,
      BoothTypeId: item.BoothTypeId,
      ProductId: item.Product,
      BoothType: item.BoothType,
      RentalStartDate: this.formatDateForApi(item.RentalStartDate),
      RentalEndDate: item.DelBooking ? this.formatDateForApi(item.RentalEndDate) : this.formatDateForApi(item.UpdatedRentalEndDate),
      RentalYearMonth: this.formatRentalYearMonthForSave(item.RentalYearMonth),
      RentalCharge: item.RentRefund != null ? -1 * parseFloat(item.RentRefund.replace(/[^0-9.-]/g, '') || '0') : null,
      SalesTax: item.SalesTax != null ? -1 * parseFloat(item.SalesTax.replace(/[^0-9.-]/g, '') || '0') : null,
      SecLevelTax: item.SecLevelTax != null ? -1 * parseFloat(item.SecLevelTax.replace(/[^0-9.-]/g, '') || '0') : null,
      BoothReserved: item.MakeAvail ? false : true,
      DoNotRenew: item.DelBooking == true ? item.DoNotRenew : true,
      PerDiem: item.PerDiem,
      Monday: item.Monday,
      Tuesday: item.Tuesday,
      Wednesday: item.Wednesday,
      Thursday: item.Thursday,
      Friday: item.Friday,
      Saturday: item.Saturday,
      Sunday: item.Sunday,
      JanuaryMonthPresent: item.JanuaryMonthPresent,
      FebruaryMonthPresent: item.FebruaryMonthPresent,
      MarchMonthPresent: item.MarchMonthPresent,
      AprilMonthPresent: item.AprilMonthPresent,
      MayMonthPresent: item.MayMonthPresent,
      JuneMonthPresent: item.JuneMonthPresent,
      JulyMonthPresent: item.JulyMonthPresent,
      AugustMonthPresent: item.AugustMonthPresent,
      SeptemberMonthPresent: item.SeptemberMonthPresent,
      OctoberMonthPresent: item.OctoberMonthPresent,
      NovemberMonthPresent: item.NovemberMonthPresent,
      DecemberMonthPresent: item.DecemberMonthPresent,
      Status: item.Status,
      JanRent: item.JanRent != null ? parseFloat(item.JanRent.replace(/[^0-9.-]/g, '') || '0') : null,
      FebRent: item.FebRent != null ? parseFloat(item.FebRent.replace(/[^0-9.-]/g, '') || '0') : null,
      MarRent: item.MarRent != null ? parseFloat(item.MarRent.replace(/[^0-9.-]/g, '') || '0') : null,
      AprRent: item.AprRent != null ? parseFloat(item.AprRent.replace(/[^0-9.-]/g, '') || '0') : null,
      MayRent: item.MayRent != null ? parseFloat(item.MayRent.replace(/[^0-9.-]/g, '') || '0') : null,
      JunRent: item.JunRent != null ? parseFloat(item.JunRent.replace(/[^0-9.-]/g, '') || '0') : null,
      JulRent: item.JulRent != null ? parseFloat(item.JulRent.replace(/[^0-9.-]/g, '') || '0') : null,
      AugRent: item.AugRent != null ? parseFloat(item.AugRent.replace(/[^0-9.-]/g, '') || '0') : null,
      SepRent: item.SepRent != null ? parseFloat(item.SepRent.replace(/[^0-9.-]/g, '') || '0') : null,
      OctRent: item.OctRent != null ? parseFloat(item.OctRent.replace(/[^0-9.-]/g, '') || '0') : null,
      NovRent: item.NovRent != null ? parseFloat(item.NovRent.replace(/[^0-9.-]/g, '') || '0') : null,
      DecRent: item.DecRent != null ? parseFloat(item.DecRent.replace(/[^0-9.-]/g, '') || '0') : null,
      PerdiemRent: item.PerdiemRent != null ? parseFloat(item.PerdiemRent.replace(/[^0-9.-]/g, '') || '0') : null,
      BookingLog: item.BookingLog,
      MakeAvail: item.MakeAvail,
      DeleteBooking: item.DelBooking,
      ZeroOut: item.ZeroOut
    }));

    const obj = {
      MonthlyRentalBooth: cleanedDeleteBooking,
      DeleteRentalOtherItems: cleanedselectedOtherItems,
      rent_refund: rentRefund,
      othercharge_refund: OtheritemrentRefund,
      salestax_refund: salestaxrefund,
      secleveltax_refund: secleveltaxrefund,
      balanceDue: balanceDue,
      VendorId: vendorid,
      AmountPaid_Total: AmountPaid,
      AmountPaid_cash: AmountPaid_cash,
      AmountPaid_CC: AmountPaid_CC,
      TransactionDate: this.DeleteRentalForm.get('TransactionDate').value,
      VerifoneId: this.VerifoneId,
      notes: this.defaultRentalNotes,
      SelectedTransactionId: '0',
      TerminalName: terminalName,
      PriorBalance: priorArBalanceValue,
      IsRefundMode: isRefundMode
    };

    this.loaderIcon = Promise.resolve(true);
    const sub = this.deleteRentalService.SaveDeleteCMonthlyRentals(obj)
      .subscribe((res: any) => {
        if (res.Success) {
          this.toastr.success($localize`Selected bookings have been successfully deleted.`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
          let ArcNumber = res.Id;
          let shouldDisplayReceipt = this.DeleteRentalForm.controls['ReceiptAndContractSetting'].get('displayReceipt').value;
          let shouldPrintReceipt = this.DeleteRentalForm.controls['ReceiptAndContractSetting'].get('printReceipt').value;
          let shouldEmailReceipt = this.DeleteRentalForm.get('ReceiptAndContractSetting.emailReceipt')?.value;
          if (shouldPrintReceipt) {
            this.printDeleteRentalReceipt(ArcNumber);
          }

          if (shouldDisplayReceipt) {
            this.viewDeleteRentalReceipt(ArcNumber);
          }

          if (shouldEmailReceipt) {
            this.emailDeleteRentalReceipt(ArcNumber);
          }

          this.resetForm();
          this.loaderIcon = Promise.resolve(false);

        } else {
          this.toastr.error($localize`Failed to delete selected bookings.`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
          this.loaderIcon = Promise.resolve(false);
        }
      }, (error) => {
        this.toastr.error($localize`An unexpected error occurred.`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
      });
    this.subscriptions.push(sub);
  }

  getVendorBalances() {
    this.subscriptions.push(
      this.vendorService.getVendorBalances(this.selectedvendorId)
        .subscribe(response => {
          if (response) {
            const priorBalanceNum = Number(response.PriorBalance ?? 0);

            this.DeleteRentalForm.controls['refundCharges'].patchValue({
              priorArBalance: this.customCurrency.transform(priorBalanceNum.toString()),
              totalRefundAmt: this.customCurrency.transform((-1 * priorBalanceNum).toString())
            });

            this.DeleteRentalForm.controls['otherRefundCharges'].patchValue({
              balanceDue: this.customCurrency.transform(priorBalanceNum.toString())
            });
          }
        })
    );
  }

  updateRefundCheckboxState() {
    const vendorBalance =
      this.parseCurrencyValue(
        this.DeleteRentalForm.get('otherRefundCharges.balanceDue')?.value || '0'
      );

    const refundControl = this.DeleteRentalForm.get('isRefundMode');

    if (vendorBalance < 0) {
      refundControl.enable();
    } else {
      refundControl.disable();
      refundControl.setValue(false);
    }
  }

  formatRentalYearMonthForSave(value: string): string {
    if (!value) {
      return '';
    }
    // Already in YYYYMM format
    if (/^\d{6}$/.test(value)) {
      return value;
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return '';
    }
    const year = date.getFullYear();
    const month =
      (date.getMonth() + 1)
        .toString()
        .padStart(2, '0');

    return `${year}${month}`;
  }

  saveRentalNotes() {
    this.DeleteRentalForm.patchValue({
      rentalNotes: this.defaultRentalNotes
    });
  }

  loadDefaultRentalNotes() {
    this.defaultRentalNotes = this.DeleteRentalForm.controls['defaultRentalNotes'].value;
  }

  loadVendorComments() {
    this.vendorComments = this.DeleteRentalForm.get('VendorComments')?.value || '';
  }

  getVendorComment() {
    const sub = this.vendorService.GetVendorDashboardById(this.selectedvendorId).subscribe((response) => {
      if (response && response.body) {
        const comment = response.body.Comment ?? '';
        this.DeleteRentalForm.patchValue({
          VendorComments: comment
        });
        this.vendorComments = comment;
      }
    });
    this.subscriptions.push(sub);
  }

  async onBoothSearch(): Promise<void> {
    const canContinue = await this.confirmUnsavedChanges();

    if (!canContinue) {
      return;
    }

    const boothNo = this.DeleteRentalForm.get('txtBooth')?.value;

    if (!boothNo) {
      this.showWarning('Please enter Booth Number');
      return;
    }

    this.loaderIcon = Promise.resolve(true);

    this.layoutService.validateBoothNumber(boothNo)
      .pipe(take(1))
      .subscribe({
        next: (isValid: boolean) => {

          if (!isValid) {
            this.loaderIcon = Promise.resolve(false);
            this.showWarning('No such Booth Number exists !');
            return;
          }

          this.vendorService.getVendorByBoothNumber(boothNo)
            .pipe(take(1))
            .subscribe({
              next: (res) => {
                if (res?.Success && res.Id > 0) {
                  this.selectedvendorId = res.Id;

                  this.getVendorInfoById(res.Id);
                } else {
                  this.loaderIcon = Promise.resolve(false);
                  this.showWarning(
                    res?.Message ?? 'No vendor assigned to this booth for the current month'
                  );
                }
              },
              error: () => {
                this.loaderIcon = Promise.resolve(false);
                this.showWarning('Error occurred while searching booth');
              }
            });
        },
        error: () => {
          this.loaderIcon = Promise.resolve(false);
          this.showWarning('Error occurred while validating booth number');
        }
      });
  }

  async getVendorInfoById(vendorId: number): Promise<void> {
    this.vendorService.GetVendorById(vendorId)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          if (res) {
            this.DeleteRentalForm.patchValue({
              chkVendorIdValue: res.MarketVendorId,
              chkVendorName: res.VendorName,
              VendorComments: res.VendorCommment
            });
            this.vendorComments = res.VendorCommment;
            this.loadVendorDetails();
          }

          this.loaderIcon = Promise.resolve(false);
        },
        error: () => {
          this.loaderIcon = Promise.resolve(false);
          this.showWarning('Failed to load vendor details');
        }
      });
  }

  saveVendorComments() {
    const obj = {
      VendorId: this.selectedvendorId,
      Comment: this.vendorComments
    };

    this.subscriptions.push(
      this.vendorService.UpdateOrSaveVendorComment(obj).subscribe(
        (res: any) => {
          if (res.Success) {
            this.toastr.success(
              $localize`Vendor comments saved successfully`,
              'Success',
              this.sharedHTMLSettings.ToasterConfig
            );
            this.DeleteRentalForm.patchValue({
              VendorComments: this.vendorComments
            });
          } else {
            this.toastr.error(
              $localize`Error occurred while saving vendor comments`,
              'Error',
              this.sharedHTMLSettings.ToasterConfig
            );
          }
          this.getVendorComment();
        },
        (err) => {
          this.toastr.error(
            $localize`Error occurred while saving vendor comments`,
            'Error',
            this.sharedHTMLSettings.ToasterConfig
          );
        }
      )
    );
  }

  getRentalPaymentSettings() {
    const sub = this.operationRentalService.getRentalSettings().subscribe((res: any) => {
      if (res && res.DefaultRentalType != null && res.DefaultRentalType > 0) {
        this.DeleteRentalForm.get('rentalType').setValue(res.DefaultRentalType.toString());
      }
    });

    this.subscriptions.push(sub);
  }

  async getVendorById(): Promise<void> {
    const canContinue = await this.confirmUnsavedChanges();
    if (!canContinue) {
      return;
    }

    this.selectedvendorId = 0;
    const vendorId = this.DeleteRentalForm.get('chkVendorIdValue')?.value;

    if (!vendorId) {
      this.DeleteRentalForm.patchValue({ chkVendorName: '', chkVendorIdValue: '' });
      return;
    }

    this.subscriptions.push(
      this.vendorService.getVendorInfoByMarketVendorId(vendorId)
        .pipe(take(1))
        .subscribe((res) => {
          if (res?.VendorId) {
            this.DeleteRentalForm.patchValue({
              chkVendorName: res.VendorName,
              VendorComments: res.VendorCommment
            });
            this.vendorComments = res.VendorCommment;
            this.selectedvendorId = res.VendorId;
            this.loadVendorDetails();
          }
          else {
            this.DeleteRentalForm.patchValue({
              chkVendorIdValue: '',
              chkVendorName: '',
            });
            this.showWarning($localize`Vendor ID does not exist.`);
          }
        })
    );
  }

  private showWarning(message: string) {
    Swal.fire({
      title: $localize`Warning`,
      text: message,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
  }

  async openVendorSearch(): Promise<void> {
    const canContinue = await this.confirmUnsavedChanges();

    if (!canContinue) {
      return;
    }

    const modal = new bootstrap.Modal(
      document.getElementById('vendorSearchModal')
    );

    modal.show();
  }

  onVendorSelected(vendor: any) {
    this.DeleteRentalForm.patchValue({
      chkVendorIdValue: vendor.marketVendorId,
      chkVendorName: vendor.vendorName
    });
    this.selectedvendorId = vendor.vendorId;
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    this.loadVendorDetails();
  }

  private getDeleteRentalReceiptPayload(accountReceiptId: number) {
    const rentalType = Number(this.DeleteRentalForm.get('rentalType')?.value);

    let receiptId = 139;

    return {
      VendorId: this.selectedvendorId,
      AccountReceiptId: accountReceiptId,
      RentalType: rentalType,
      PaymentOnly: false,
      DocumentId: receiptId,
      VendorHistory: false,
      Deposit: false,
      DisplayBillNum: false,
      MerchantCopy: false,
      CustomerCopy: false,
      SignBase64: ''
    };
  }

  private printDeleteRentalReceipt(accountReceiptId: number) {
    const payload = this.getDeleteRentalReceiptPayload(accountReceiptId);
    this.loaderIcon = Promise.resolve(true);

    this.vendorService.DisplayDeleteRentalReceipt(payload).subscribe({
      next: (res: any) => {
        const pdfDataUrl = res?.Message;
        if (!pdfDataUrl?.startsWith('data:application/pdf;base64,')) {
          this.loaderIcon = Promise.resolve(false);
          Swal.fire('Error', 'Invalid PDF data', 'error');
          return;
        }

        const pdfBase64 = pdfDataUrl.split(',')[1];
        this.loaderIcon = Promise.resolve(false);

        printJS({
          printable: pdfBase64,
          type: 'pdf',
          base64: true
        });
      },
      error: () => {
        this.loaderIcon = Promise.resolve(false);
        Swal.fire('Error', 'Failed to print receipt', 'error');
      }
    });
  }

  private viewDeleteRentalReceipt(accountReceiptId: number) {
    const payload = this.getDeleteRentalReceiptPayload(accountReceiptId);

    this.loaderIcon = Promise.resolve(true);
    this.pdfUrl = null;

    this.vendorService.DisplayDeleteRentalReceipt(payload).subscribe({
      next: (res: any) => {
        const pdfDataUrl = res?.Message;
        if (!pdfDataUrl?.startsWith('data:application/pdf;base64,')) {
          this.loaderIcon = Promise.resolve(false);
          Swal.fire('Error', 'Invalid PDF data', 'error');
          return;
        }

        const base64 = pdfDataUrl.split(',')[1];
        const blob = this.base64ToBlob(base64, 'application/pdf');
        this.pdfUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(
            URL.createObjectURL(blob)
          );

        this.loaderIcon = Promise.resolve(false);

        const modalEl = document.getElementById('viewReceiptModal');
        if (modalEl) {
          const modal =
            (window as any).bootstrap.Modal.getOrCreateInstance(modalEl);
          modal.show();
        }
      },
      error: () => {
        this.loaderIcon = Promise.resolve(false);
        Swal.fire('Error', 'Failed to load receipt', 'error');
      }
    });
  }

  private emailDeleteRentalReceipt(accountReceiptId: number) {
    const payload = this.getDeleteRentalReceiptPayload(accountReceiptId);
    this.loaderIcon = Promise.resolve(true);

    this.vendorService.DisplayDeleteRentalReceipt(payload).subscribe({
      next: (res: any) => {
        const pdfDataUrl = res?.Message;

        if (!pdfDataUrl?.startsWith('data:application/pdf;base64,')) {
          this.loaderIcon = Promise.resolve(false);
          Swal.fire('Error', 'Invalid PDF data', 'error');
          return;
        }

        const emailData = [{
          AccountReceiptID: accountReceiptId,
          VendorID: this.selectedvendorId,
          BaseTemplateID: EBaseTemplateID.RentalReceipt,
          AttachmentFile: pdfDataUrl,
          AttachmentFileName: 'DeleteRentalReceipt.pdf',
          FileType: 'application/pdf',
          Subject: 'Deleted Rental Receipt'
        }];

        this.generalService.composeEmails(emailData).subscribe({
          next: (r: any) => {
            this.loaderIcon = Promise.resolve(false);

            if (r?.Success) {
              Swal.fire('Success', 'Receipt emailed successfully', 'success');
            } else {
              Swal.fire('Error', r?.Message || 'Email failed', 'error');
            }
          },
          error: () => {
            this.loaderIcon = Promise.resolve(false);
            Swal.fire('Error', 'Email sending failed', 'error');
          }
        });
      },
      error: () => {
        this.loaderIcon = Promise.resolve(false);
        Swal.fire('Error', 'Failed to generate receipt', 'error');
      }
    });
  }

  private base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
